import api from './api';

/**
 * Carrier contacts (highway.carriercontact) — keyed by carrierrecno. A flat
 * shape (type / name / phone / fax / email / defaultcontact), distinct from the
 * reusable cms.contactinfo subtable. Served by the /carriercontacts router and
 * used by the Carrier Profiles edit drawer.
 */
export interface CarrierContact {
  recno: number;
  carrierrecno: number;
  contacttype: string;
  contactname: string;
  contactphone: string;
  contactfax: string;
  contactemail: string;
  defaultcontact: string; // 'Y' | 'N'
  deleted: string;
}

export async function listCarrierContacts(carrierrecno: number): Promise<CarrierContact[]> {
  const res = await api.get('/carriercontacts', { params: { carrierrecno } });
  return res.data?.data || [];
}

export async function createCarrierContact(payload: Record<string, any>): Promise<{ recno: number }> {
  const res = await api.post('/carriercontacts', payload);
  return res.data?.data;
}

export async function updateCarrierContact(recno: number, payload: Record<string, any>): Promise<void> {
  await api.put(`/carriercontacts/${recno}`, payload);
}

export async function deleteCarrierContact(recno: number): Promise<void> {
  await api.delete(`/carriercontacts/${recno}`);
}
